import { Grid, Typography, useMediaQuery } from '@mui/material';
import { styled } from '@mui/system';
import React, { useMemo } from 'react';
import { useTheme } from '@emotion/react';
import useIsKioskMode from '../util/useIsKioskMode';

const Heading = styled(Typography)({
  textAlign: 'center',
  // color: 'white',
  marginBottom: '50px',
});

export default function RsvpHeading({ logoUrl, inviteForm }) {
  const theme = useTheme();
  const isIframe = useMemo(() => window.self !== window.top, []);
  const isKioskMode = useIsKioskMode();
  const matchesSm = useMediaQuery(theme.breakpoints.down('sm'));
  // eslint-disable-next-line no-nested-ternary
  const logoWidth = matchesSm ? 200 : '50%';
  if (isIframe || isKioskMode) return null;
  return (
    <Heading variant="h3" sx={{ marginBottom: 6, fontSize: '2.8rem' }}>
      <Grid container sx={{ marginBottom: 2 }}>
        <Grid item xs={12}>
          <img src={logoUrl} alt="logo" style={{ maxWidth: logoWidth }} />
        </Grid>
      </Grid>
      {inviteForm.title}
    </Heading>
  );
}
